<template>
  <div class="recursos-operacionais-split">
    <v-dialog v-model="confirmPassengerDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('crudLinhas.messages.systemMessage') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ confirmPassengerMessage }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red accent-4" class="white--text" @click="dismissPassengerRemoval">
            {{ $t('button.dismiss') }}
          </v-btn>
          <v-btn color="red accent-4" class="white--text" @click="confirmPassengerRemoval">
            {{ $t('button.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row no-gutters align="stretch" class="recursos-operacionais-split__row">
      <v-col cols="12" md="5" class="pr-md-2 recursos-operacionais-split__list">
        <slot />
      </v-col>
      <v-col cols="12" md="7" class="pl-md-2 recursos-operacionais-split__detail">
        <div class="recursos-operacionais-split__sticky">
          <recursos-operacionais-detalhe-panel
            ref="detalhePanel"
            :linha="linha"
            :preview-type="previewType"
            :preview-item="previewItem"
            :preview-items="previewItems"
            :additional-linhas="additionalLinhas"
            :initial-tab="initialTab"
            :initial-tab-key="initialTabKey"
            :parametros-total="parametrosTotal"
            :parametros-page="parametrosPage"
            :parametros-label="parametrosLabel"
            :preferred-route-ids="preferredRouteIds"
            :historico-sessao-id="historicoSessaoId"
            :historico-sessao-origem-id="historicoSessaoOrigemId"
            :sentidos="sentidosInternos"
            :token="token"
            :can-edit="canEdit"
            :can-insert="canInsert"
            :tipos-cerca="tiposCercaInternos"
            :tipos-rota="tiposRotaInternos"
            :linha-create-preview-rotas="linhaCreatePreviewRotas"
            :linha-create-preview-cerca="linhaCreatePreviewCerca"
            :linha-create-preview-cercas-linha="linhaCreatePreviewCercasLinha"
            :linha-create-preview-prefer-unidade="linhaCreatePreviewPreferUnidade"
            :cerca-create-select-route="cercaCreateSelectRoute"
            :cerca-create-route-id.sync="cercaCreateRouteIdInternal"
            :area-map-data="areaMapData"
            @passengers-changed="$emit('passengers-changed')"
            @cercas-changed="$emit('cercas-changed')"
            @rotas-changed="$emit('rotas-changed')"
            @turnos-changed="$emit('turnos-changed')"
            @deallocate-passenger="requestPassengerRemoval"
            @map-action="$emit('map-action', $event)"
            @preview-changed="$emit('preview-changed', $event)"
            @unidade-linhas-changed="$emit('unidade-linhas-changed')"
            @parametros-save="$emit('parametros-save')"
            @update:parametrosPage="$emit('update:parametrosPage', $event)"
            @parameters-tab-opened="$emit('parameters-tab-opened')"
          >
            <template #parametros><slot name="parametros" /></template>
            <template #create-entity><slot name="create-entity" /></template>
          </recursos-operacionais-detalhe-panel>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import apiController from "@/utils/apiController";
import translateDbField from "@/utils/translateDbField";
import RecursosOperacionaisDetalhePanel from "./RecursosOperacionaisDetalhePanel.vue";

export default {
  name: "RecursosOperacionaisSplitLayout",
  components: {
    RecursosOperacionaisDetalhePanel,
  },
  props: {
    linha: { type: Object, default: null },
    token: { type: String, default: null },
    canEdit: { type: Boolean, default: false },
    canInsert: { type: Boolean, default: false },
    previewType: { type: String, default: null },
    previewItem: { type: Object, default: null },
    /** Todos os itens marcados na tabela; habilita a exibição simultânea no mapa. */
    previewItems: { type: Array, default: () => [] },
    /** Outras linhas marcadas na tabela (contexto "linhas"). */
    additionalLinhas: { type: Array, default: () => [] },
    sentidos: { type: Array, required: false },
    tiposCerca: { type: Array, required: false },
    tiposRota: { type: Array, required: false },
    initialTab: { type: Number, default: 0 },
    initialTabKey: { type: String, default: null },
    parametrosTotal: { type: Number, default: 0 },
    parametrosPage: { type: Number, default: 0 },
    parametrosLabel: { type: String, default: null },
    preferredRouteIds: { type: Array, default: () => [] },
    historicoSessaoId: { type: String, default: null },
    historicoSessaoOrigemId: { type: String, default: null },
    linhaCreatePreviewRotas: { type: Array, default: () => [] },
    linhaCreatePreviewCerca: { type: Object, default: null },
    linhaCreatePreviewCercasLinha: { type: Array, default: () => [] },
    linhaCreatePreviewPreferUnidade: { type: Boolean, default: false },
    cercaCreateSelectRoute: { type: Boolean, default: false },
    cercaCreateRouteId: { type: [Number, String], default: null },
    /** Módulo de áreas: { area, unidades, sugestoes } repassado ao AreaMapEditor. */
    areaMapData: { type: Object, default: null },
  },
  data: () => ({
    sentidosCarregados: [],
    tiposCercaCarregados: [],
    tiposRotaCarregados: [],
    confirmPassengerDialog: false,
    pendingPassengerRemoval: null,
  }),
  computed: {
    sentidosInternos() {
      return Array.isArray(this.sentidos) ? this.sentidos : this.sentidosCarregados;
    },
    tiposCercaInternos() {
      return Array.isArray(this.tiposCerca) ? this.tiposCerca : this.tiposCercaCarregados;
    },
    tiposRotaInternos() {
      return Array.isArray(this.tiposRota) ? this.tiposRota : this.tiposRotaCarregados;
    },
    confirmPassengerMessage() {
      const passageiro = this.pendingPassengerRemoval || {};
      const nome = passageiro.nome_completo || passageiro.nome || passageiro.matricula
        || passageiro.id_pessoa;
      return this.$t("crudLinhas.detail.passengers.confirmRemoval", { nome });
    },
    cercaCreateRouteIdInternal: {
      get() {
        return this.cercaCreateRouteId;
      },
      set(val) {
        this.$emit("update:cercaCreateRouteId", val);
      },
    },
  },
  created() {
    if (!Array.isArray(this.sentidos)) this.populaSentidos();
    if (!Array.isArray(this.tiposCerca)) this.populaTiposCerca();
    if (!Array.isArray(this.tiposRota)) this.populaTiposRota();
  },
  methods: {
    getDetalhePanel() {
      return this.$refs.detalhePanel;
    },
    abrirAbaRotas() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.abrirAbaRotas === "function") panel.abrirAbaRotas();
    },
    abrirAbaCercas() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.abrirAbaCercas === "function") panel.abrirAbaCercas();
    },
    abrirAbaTurnos() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.abrirAbaTurnos === "function") panel.abrirAbaTurnos();
    },
    abrirAbaLinhas() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.abrirAbaLinhas === "function") panel.abrirAbaLinhas();
    },
    abrirAbaPorChave(key) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.abrirAbaPorChave === "function") panel.abrirAbaPorChave(key);
    },
    focarAssociacaoLinhas() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.focarAssociacaoLinhas === "function") {
        panel.focarAssociacaoLinhas();
      }
    },
    openCreateDrawer(opts) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.openCreateDrawer === "function") {
        panel.openCreateDrawer(opts);
      }
    },
    closeCreateDrawer(opts) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.closeCreateDrawer === "function") {
        panel.closeCreateDrawer(opts);
      }
    },
    previewAndFocusCerca(cerca, opts) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.previewAndFocusCerca === "function") {
        panel.previewAndFocusCerca(cerca, opts);
      }
    },
    setPickLocationMode(on) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.setPickLocationMode === "function") {
        panel.setPickLocationMode(on);
      }
    },
    setDrawPolygonMode(on) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.setDrawPolygonMode === "function") {
        panel.setDrawPolygonMode(on);
      }
    },
    setDrawRouteMode(on) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.setDrawRouteMode === "function") {
        panel.setDrawRouteMode(on);
      }
    },
    async criarCercaEAssociarNaLinha(payload, opts) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.criarCercaEAssociarNaLinha === "function") {
        return panel.criarCercaEAssociarNaLinha(payload, opts);
      }
      return { ok: false, message: null };
    },
    setCercaCreateRouteId(idRota) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.setCercaCreateRouteId === "function") {
        panel.setCercaCreateRouteId(idRota);
      }
    },
    finalizeDrawFenceIfPending() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.finalizeDrawFenceIfPending === "function") {
        return panel.finalizeDrawFenceIfPending();
      }
      return false;
    },
    finalizeDrawRouteIfPending() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.finalizeDrawRouteIfPending === "function") {
        return panel.finalizeDrawRouteIfPending();
      }
      return false;
    },
    previewAndFocusRota(rota, opts) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.previewAndFocusRota === "function") {
        panel.previewAndFocusRota(rota, opts);
      }
    },
    clearCreateDraftRota() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.clearCreateDraftRota === "function") {
        panel.clearCreateDraftRota();
      }
    },
    clearCreateDraft() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.clearCreateDraft === "function") {
        panel.clearCreateDraft();
      }
    },
    setLinhaCreatePreviewRotas(rotas) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.setLinhaCreatePreviewRotas === "function") {
        panel.setLinhaCreatePreviewRotas(rotas);
      }
    },
    setLinhaCreatePreviewUnidade(unit) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.setLinhaCreatePreviewUnidade === "function") {
        panel.setLinhaCreatePreviewUnidade(unit);
      }
    },
    clearLinhaCreatePreview() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.clearLinhaCreatePreview === "function") {
        panel.clearLinhaCreatePreview();
      }
    },
    abrirAbaParametros() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.abrirAbaParametros === "function") panel.abrirAbaParametros();
    },
    centralizarMapaNaLinha() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.centralizarMapaNaLinha === "function") {
        panel.centralizarMapaNaLinha();
      }
    },
    preservarAbaNaProximaLinha() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.preservarAbaNaProximaLinha === "function") {
        panel.preservarAbaNaProximaLinha();
      }
    },
    focarMapaSemTrocarAba() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.focarMapaSemTrocarAba === "function") {
        panel.focarMapaSemTrocarAba();
      }
    },
    mostrarLinhaNoMapa() {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.mostrarLinhaNoMapa === "function") {
        return panel.mostrarLinhaNoMapa();
      }
      if (panel && typeof panel.centralizarMapaNaLinha === "function") {
        return panel.centralizarMapaNaLinha();
      }
      return undefined;
    },
    mostrarRotaNoMapa(item) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.mostrarRotaNoMapa === "function") {
        return panel.mostrarRotaNoMapa(item);
      }
      return Promise.resolve();
    },
    mostrarCercaNoMapa(item) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.mostrarCercaNoMapa === "function") {
        return panel.mostrarCercaNoMapa(item);
      }
      return Promise.resolve();
    },
    async onDeallocate(passageiro) {
      const panel = this.$refs.detalhePanel;
      if (panel && typeof panel.onDeallocate === "function") {
        await panel.onDeallocate(passageiro);
      }
    },
    requestPassengerRemoval(passageiro) {
      if (!passageiro) return;
      this.pendingPassengerRemoval = passageiro;
      this.confirmPassengerDialog = true;
    },
    dismissPassengerRemoval() {
      this.confirmPassengerDialog = false;
      this.pendingPassengerRemoval = null;
    },
    async confirmPassengerRemoval() {
      const passageiro = this.pendingPassengerRemoval;
      this.confirmPassengerDialog = false;
      this.pendingPassengerRemoval = null;
      if (!passageiro) return;
      await this.onDeallocate(passageiro);
    },
    populaSentidos() {
      apiController.request(apiController.endpoints.getallSentidos, {
        onSuccess: (response) => {
          this.sentidosCarregados = (response.data || []).map((sentido) => {
            const translated = translateDbField(
              sentido.translation_key,
              sentido.descricao_sentido
            );
            return { ...sentido, descricao_sentido: translated };
          });
        },
      });
    },
    populaTiposCerca() {
      apiController.request(apiController.endpoints.getTiposcerca, {
        onSuccess: (response) => {
          this.tiposCercaCarregados = (response.data || []).map((tipoCerca) => {
            const translated = translateDbField(
              tipoCerca.translation_key,
              tipoCerca.descricao_tipo_cerca
            );
            return { ...tipoCerca, descricao_tipo_cerca: translated };
          });
        },
      });
    },
    populaTiposRota() {
      apiController.request(apiController.endpoints.getTiposrota, {
        onSuccess: (response) => {
          this.tiposRotaCarregados = (response.data || []).map((tipoRota) => {
            const translated = translateDbField(
              tipoRota.translation_key,
              tipoRota.descricao_tipo_rota
            );
            return { ...tipoRota, descricao_tipo_rota: translated };
          });
        },
      });
    },
  },
};
</script>

<style scoped>
.recursos-operacionais-split {
  --recursos-operacionais-top-gap: 10px;
  width: 100%;
  max-width: 100%;
}
.recursos-operacionais-split__row {
  align-items: stretch;
}
.recursos-operacionais-split__list {
  overflow: visible;
}
.recursos-operacionais-split__list >>> .v-data-table.elevation-7 {
  margin-top: var(--recursos-operacionais-top-gap) !important;
}
.recursos-operacionais-split__list >>> .v-data-table {
  font-size: 0.75rem;
}
.recursos-operacionais-split__list >>> .v-data-table .v-data-table-header th,
.recursos-operacionais-split__list >>> .v-data-table td {
  padding: 0 6px !important;
  height: 32px !important;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.75rem;
  line-height: 1.25;
}
.recursos-operacionais-split__list >>> .v-data-table .v-data-table-header th {
  max-width: 110px;
  font-size: 0.7rem;
  font-weight: 600;
}
.recursos-operacionais-split__list >>> .v-data-table td:last-child,
.recursos-operacionais-split__list >>> .v-data-table th:last-child,
.recursos-operacionais-split__list >>> .v-data-table td:first-child,
.recursos-operacionais-split__list >>> .v-data-table th:first-child {
  max-width: none;
  overflow: visible;
}
.recursos-operacionais-split__list >>> .v-data-table td .v-icon,
.recursos-operacionais-split__list >>> .v-data-table th .v-icon {
  font-size: 18px !important;
}
.recursos-operacionais-split__detail {
  min-width: 0;
  max-width: 100%;
  overflow: visible !important;
}
.recursos-operacionais-split__sticky {
  position: sticky;
  top: 64px;
  margin-top: var(--recursos-operacionais-top-gap);
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: calc(100vh - 64px - var(--recursos-operacionais-top-gap) - 12px);
  max-height: calc(100vh - 64px - var(--recursos-operacionais-top-gap) - 12px);
  overflow: hidden;
  z-index: 2;
}
.recursos-operacionais-split__sticky >>> .linha-detalhe-panel {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  height: 100%;
  max-height: 100%;
  width: 100%;
  max-width: 100%;
  position: static;
}

@media (max-width: 959px) {
  .recursos-operacionais-split__sticky {
    position: static;
    height: min(70vh, calc(100vh - 64px - var(--recursos-operacionais-top-gap) - 12px));
    max-height: min(70vh, calc(100vh - 64px - var(--recursos-operacionais-top-gap) - 12px));
  }
}
</style>
